import React, { useState, useEffect } from 'react';
import { Route, Switch, useLocation, Redirect } from 'react-router-dom';

// import Header from './layout/Header';
import HeaderSimple from './layout/HeaderSimple';
import Footer from './layout/Footer';
import config from '../config';
import axios from 'axios';
// import homeContainer from './layout/Home';

// Funding Process Components Imports
import GenerateOfferContainer from './funding/generateOffer/GenerateOfferContainer';
import ContractReviewContainer from './funding/contractReview/ContractReviewContainer';
import SignContractContainer from './funding/signContract/SignContractContainer';
import SignDisclosureContainer from './funding/signDisclosure/SignDisclosureContainer';
import VerifyContractContainer from './funding/verifyContract/VerifyContractContainer';
import VerifyContractDoneComponent from './funding/verifyContract/VerifyContractDoneComponent';
import BankVerificationContainer from './funding/bankVerification/BankVerificationContainer';
import BankVerificationContainerbyOpp from './funding/bankVerificationbyOpp/BankVerificationContainer';
import BankVerificationContainerbyAcc from './funding/bankVerificationbyAcc/BankVerificationContainer';
import UploadDocsContainer from './funding/uploadDocs/UploadDocsContainer';
import UploadDocsContainerbyOpp from './funding/uploadDocsbyOpp/UploadDocsContainer';
import ProcessDoneComponent from './funding/common/ProcessDoneComponent';
import BThankYou from './funding/ThankYou';

// Onboarding-Application Process Components Imports
import MerchantProvider from "./onboarding/application/context/MerchantStateContext";
import Funding from "./onboarding/application/components/Funding";
import BusinessType from "./onboarding/application/components/BusinessType";
import BusinessLocation from "./onboarding/application/components/BusinessLocation";
import Personal from "./onboarding/application/components/Personal";
import PersonalInformation from "./onboarding/application/components/PersonalInformation";
import Esign from "./onboarding/application/components/Esign/Esign";
// import ReviewSignature from "./onboarding/application/components/ReviewSignature";
import ReviewSignature from './onboarding/application/components/signatureReview/ReviewSignature ';
import Upload from "./onboarding/application/components/Upload/Upload";
import AppAdditions from "./onboarding/application/components/AppAdditions";
import GenericUpload from "./onboarding/application/components/GenericUploadComponent/GenericUpload";
import GenericUploadbyOpp from "./onboarding/application/components/GenericUploadComponentbyOpp/GenericUpload";
import ThankYou from "./onboarding/application/components/ThankYou";
import LinkExpired from "./onboarding/application/components/LinkExpired";
import PageNotFound from "./onboarding/application/components/404Page";
import Home from './Home';

// Onboarding-Syndicator Process Components Imports
import StateContextProvider from './onboarding/syndicator/context/StateContext';
import Account from './onboarding/syndicator/components/Account';
import Contact from './onboarding/syndicator/components/Contact';
import SThankYou from './onboarding/syndicator/components/ThankYou';

// StandAlone Signature Process
import SignatureStateContext from './funding/documentSignature/documentSignatureContext';
import ContractContainer from './funding/documentSignature/components/ContractContainer';
import ContractCancelledComponent from './funding/documentSignature/components/ContractCancelledComponent';
import ContractSuccessComponent from './funding/documentSignature/components/ContractSuccessComponent';

// Cookie Consent
import CookieConsent from "react-cookie-consent";

import './App.css';
import SubmissionDone from './onboarding/application/components/SubmissionDone';

import TagManager from 'react-gtm-module';

import PickVariation from './onboarding/application/components/PickVariation';

// import RedirectComponent from './redirect/redirect';

/* Short URL Component renders view to related to original url */
import ShortUrlResolver from './shortUrl/ShortUrlResolver';

// Marketplace App Connect Flow
import Connect from './marketplace/components/Connect';
import Connected from './marketplace/components/Connected';
import Disconnected from './marketplace/components/Disconnected';

export default function App(props) {
  const location = useLocation();
  const [internalIp, setInternalIp] = useState();
  const [showHeader, setShowHeader] = useState(true);
  const [showOverlay, setShowOverlay] = useState(true);
  const [consentGiven, setConsentGiven] = useState(false);

  // Show or hide header for specific paths
  const pathNameArray = ['/onboarding/merchant/landing'];
  useEffect(() => {
    if (pathNameArray.includes(location.pathname)) {
      setShowHeader(false);
    } else {
      setShowHeader(true);
    }
  }, [location.pathname]);



  // Check internal IP for some logic
  useEffect(() => { checkInternalIp() }, []);
  const checkInternalIp = () => {
    axios.defaults.withCredentials = true;
    axios.get(`${config.apiUrl}/api/uplyftOnboarding/checkHost`)
      .then(res => {
        if (res.data.error) {
          console.error(res.data.error);
        } else {
          console.log('checkInternalIp response:', res.data.isInternalIp);
          setInternalIp(res.data.isInternalIp);
        }
      })
      .catch(err => {
        console.error('checkInternalIp error:', err);
        setInternalIp(false); // fallback
      });
  };

  // Helper to read cookies as map
  function readCookiesMap() {
    if (typeof document === 'undefined') return {};
    return document.cookie
      .split('; ')
      .filter(Boolean)
      .reduce((acc, pair) => {
        const [name, ...rest] = pair.split('=');
        acc[name] = rest.join('=');
        return acc;
      }, {});
  }



  // On mount, determine consent status from cookies

  useEffect(() => {
	const cookies = readCookiesMap();
	const consent = cookies['yourCookieConsent'];
	const hasGa = !!cookies['_ga'] || !!cookies['_gid'];
  
	const setUrlParam = (key, value) => {
	  const url = new URL(window.location.href);
	  url.searchParams.set(key, value);
	  window.history.replaceState({}, '', url);
	};
  
	// If consent given in modal or GA cookie present (implicit consent)
	if (consent === 'true' || (hasGa && !consent)) {
	  setConsentGiven(true);
	  setShowOverlay(false);
  
	  if (consent === 'true') {
		// setUrlParam('utm_consent', 'implicit_here');  //comment utm
	} else if (hasGa && !consent) {
		// set the utm param
		// setUrlParam('utm_consent', 'given_elsewhere');  //comment utm
	  
		// set the cookie for 150 days
		document.cookie = `yourCookieConsent=true; path=/; max-age=${150 * 24 * 60 * 60}; SameSite=Lax`;
		console.log('Detected GA cookie without consent cookie — setting yourCookieConsent=true');
	}
  
	  console.log('Consent detected: accepted in uplyftcapital.com');
	}
	// If consent explicitly declined
	else if (consent === 'false') {
	  setConsentGiven(false);
	  setShowOverlay(false);
	//   setUrlParam('utm_consent', 'declined');  //comment utm
	  console.log('Consent detected: declined');
	}
	// No consent found
	else {
	  setShowOverlay(true);
	  console.log('No consent found, showing overlay and modal');
	}
  }, []);
  

  // Centralized Initialize GTM
  useEffect(() => {
    if (consentGiven) {
      const tagManagerArgs = {
        gtmId: 'GTM-M7PQSTF',
        dataLayer: {
          userId: '001',
          userProject: 'project',
        },
      };
      console.log('Consent given. Initializing GTM...');
      TagManager.initialize(tagManagerArgs);
    } else {
      console.log('Consent not given. GTM not initialized.');
    }
  }, [consentGiven]);

  return (
    <>
      <div className='content'>
        {showHeader && <HeaderSimple />}
        <Switch>
          <Route exact path="/" component={Home} />

          {/* Funding Routes */}
          <Route exact path="/funding/generate-offer/:submissionUuid" component={GenerateOfferContainer} />
          <Route exact path="/funding/contract-review/:submissionUuid/:contactUuid" component={ContractReviewContainer} />
          <Route exact path="/funding/sign-contract/:submissionUuid/:contactUuid" component={SignContractContainer} />
          <Route exact path="/funding/sign-disclosure/:state/:submissionUuid/:contactUuid" component={SignDisclosureContainer} />
          <Route exact path="/funding/verify-contract/:submissionUuid/:verifierUuid" component={VerifyContractContainer} />
          <Route exact path="/funding/verify-contract-done/:submissionUuid/:verifierUuid" component={VerifyContractDoneComponent} />
          <Route exact path="/funding/bank-verification/:submissionUuid/:contactUuid" component={BankVerificationContainer} />
	    	  <Route exact path="/funding/bank-verification-1/:opportunityUuid/:contactUuid" component={BankVerificationContainerbyOpp} />
          <Route exact path="/funding/bank-verification-2/:accountUuid/:contactUuid" component={BankVerificationContainerbyAcc} />
          <Route exact path="/funding/upload-docs/:submissionUuid/:contactUuid" component={UploadDocsContainer} />
          <Route exact path="/funding/upload-docs-1/:opportunityUuid" component={UploadDocsContainerbyOpp} />  {/* Seems to be not in use */}
          <Route exact path='/funding/upload-docs-2/:opportunityUuid' render={props => <GenericUploadbyOpp {...props} />} />  {/* Seems to be not in use */}
          <Route exact path="/funding/process-done" component={ProcessDoneComponent} />
          <Route exact path='/funding/thank-you' render={props => <StateContextProvider><BThankYou {...props} /></StateContextProvider>} />

          {/* Onboarding Routes */}
          <Route exact path='/onboarding/merchant/:accountUuid/upload/:contactUuid/:opportunityUuid' render={props => <Upload {...props} />} />
          <Route exact path='/onboarding/merchant/:accountUuid/genericUpload/:contactUuid/:opportunityUuid' render={props => <GenericUpload {...props} />} />
		  <Route exact path='/onboarding/merchant/finished' render={props => <ThankYou {...props} />} />
		  <Route exact path='/onboarding/merchant/expiredlink' render={props => <LinkExpired {...props} />} />
		  <Route exact path="/onboarding/merchant/process-done" render={props => <SubmissionDone {...props} />} />
          <Route exact path='/onboarding/merchant/:accountUuid/reviewsignature/:contactUuid/:opportunityUuid' render={props => <ReviewSignature {...props} internalIp={internalIp} />} />
          <Route exact path='/onboarding/merchant/' render={props => <MerchantProvider><Funding {...props} /></MerchantProvider>} />
          <Route exact path='/onboarding/merchant/landing' render={() => <MerchantProvider><PickVariation {...props} /></MerchantProvider>} />
          <Route exact path='/onboarding/merchant/business' render={props => <MerchantProvider><BusinessType {...props} /></MerchantProvider>} />
          <Route exact path='/onboarding/merchant/address' render={props => <MerchantProvider><BusinessLocation {...props} /></MerchantProvider>} />
          <Route exact path='/onboarding/merchant/personal' render={props => <MerchantProvider><Personal {...props} /></MerchantProvider>} />
          <Route exact path='/onboarding/merchant/:accountUuid/personalinfo/:contactUuid/:opportunityUuid' render={props => <MerchantProvider><PersonalInformation {...props} /></MerchantProvider>} />
          <Route exact path='/onboarding/merchant/:accountUuid/esign/:contactUuid/:opportunityUuid' render={props => <MerchantProvider><Esign {...props} /></MerchantProvider>} />
          <Route exact path='/onboarding/merchant/:accountUuid/additions/:contactUuid/:opportunityUuid' render={props => <MerchantProvider><AppAdditions {...props} /></MerchantProvider>} />

          {/* Syndicator Routes */}
          <Route exact path='/onboarding/syndicator/contact' render={props => <StateContextProvider><Contact {...props} /></StateContextProvider>} />
          <Route exact path='/onboarding/syndicator/account' render={props => <StateContextProvider><Account {...props} /></StateContextProvider>} />
          <Route exact path='/onboarding/syndicator/thank-you' render={props => <StateContextProvider><SThankYou {...props} /></StateContextProvider>} />

          {/* Signature Process */}
          <Route exact path='/sign/test/' render={props => <SignatureStateContext><ContractContainer {...props} /></SignatureStateContext>} />
          <Route exact path='/sign/document/:documentUuid/:signerUuid' render={props => <SignatureStateContext><ContractContainer {...props} /></SignatureStateContext>} />
          <Route exact path='/sign/document/success' component={ContractSuccessComponent} />
          <Route exact path='/sign/document/cancelled' component={ContractCancelledComponent} />

          {/* Marketplace App Connect Flow */}
          <Route exact path="/marketplace/:provider/connect" component={Connect} />
          <Route exact path="/marketplace/:provider/connected" component={Connected} />
          <Route exact path="/marketplace/:provider/disconnected" component={Disconnected} />

          {/* Short URL and Redirects */}
          <Route exact path="/a/:hash" render={props => <ShortUrlResolver {...props} internalIp={internalIp} />} />
          {/* <Route exact path='/redirect' component={RedirectComponent} /> */}
          <Route exact path='/404' render={() => <PageNotFound />} />
          <Route render={() => <Redirect to='/404' />} />
        </Switch>
      </div>

      <MerchantProvider>
        <Footer {...props} />
      </MerchantProvider>

      {/* Consent Overlay as a darkened background */}
      {showOverlay && (
        <div
          style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw', height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 10000,
          }}
        />
      )}

      {/* Cookie Consent Banner */}
      {showOverlay && (
        <CookieConsent
          location="none"
          cookieName="yourCookieConsent"
          disableStyles={true}
          enableDeclineButton
          declineButtonText="Decline"
          buttonText="Ok, Got it"
          expires={150}
          onAccept={() => {
            document.cookie = `yourCookieConsent=true; path=/; max-age=${150 * 24 * 60 * 60}; SameSite=Lax`; // accept cookie last 150 days
            setConsentGiven(true);
            setShowOverlay(false);
          }}
          onDecline={() => {
            document.cookie = `yourCookieConsent=false; path=/; max-age=${48 * 60 * 60}; SameSite=Lax`; // decline cookie last 48 hours

            setConsentGiven(false);
            setShowOverlay(false);


			// This below is useless because we have no tag to track the url 
			// commented for now :/
			// we can maybe track consent_given_elsewhere or consent_given_here??
            // const url = new URL(window.location.href);
            // url.searchParams.set('utm_source', 'decline_cookie_consent');
            // window.history.replaceState({}, '', url);

            console.log('User declined cookies. GTM will not initialize.');
          }}
          containerClasses="cookie-consent-container"
          contentClasses="cookie-consent-content"
          buttonClasses="cookieConsentButton"
          declineButtonClasses="cookieConsentDeclineButton"
          buttonWrapperClasses="cookie-consent-buttons"
        >
					<img
			src="/png/cookie_consent_003.png"
			alt="Cookie Banner"
			className="cookie-consent-image"
			/>
          <div style={{ textAlign: 'left' }}>
            <h3 style={{ marginBottom: '12px', color: '#000', fontSize: '22px' }}>
              We respect your digital space
            </h3>
            <p style={{ color: '#333', fontSize: '14px', lineHeight: '1.5', marginBottom: '40px' }}>
              We use cookies (the digital kind) to personalize your experience, improve performance, and understand what matters most to you. You’re in control—feel free to adjust your preferences.
              To learn more, please visit our <a href="https://www.uplyftcapital.com/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie Policy</a>.
            </p>
          </div>
        </CookieConsent>
      )}

      {/* Styles for cookie consent */}
      <style>{`
        .cookie-consent-container {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: white;
          z-index: 10001;
          padding: 40px;
          border-radius: 12px;
          width: 90%;
          max-width: 400px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
          font-family: sans-serif;
          text-align: center;
        }
        .cookie-consent-buttons {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
        }
        .cookie-consent-buttons button {
          border: none;
          cursor: pointer;
        }
        .cookieConsentButton {
          background-color: #000;
          color: #fff;
          padding: 12px 48px;
          border-radius: 50px;
          font-size: 14px;
        }
        .cookieConsentDeclineButton {
          background: none;
          color: #9F9F9F;
          text-decoration: underline;
          font-size: 14px;
        }
		.cookie-consent-image {
			max-width: 100%;
			height: auto;
			margin-bottom: 20px;
			display: block;
		  }
		`}</style>
    </>
  );
}
